/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { AddIcon } from '../../../../../components/buttons/IconButtons';
import { CommonContractorCreateUpdateApp } from '../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp';
import { ContractorUpdateEmployeeApp } from '../../Functionality/EmployeeCreateUpdateFlows/ContractorUpdateEmployeeApp';
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';
import UnlinkDeviceBtn from '../../../../../components/buttons/UnlinkDeviceBtn';
import ContractorEmployeeUpdateWithDetails from './ContractorEmployeeUpdateWithDetails';
import ContractorEmployeeUpdateWithoutDetails from './ContractorEmployeeUpdateWithoutDetails';

const ContractorCreateEmployee = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        permission,
        params,
        dispatch,
        emptyFields,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        photoPicker,
        setPhotoPicker,
        secretKey,
        setSecretKey,
        secretModal,
        setSecretModal,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        showUnlinkBtn,
        setModified,
        handleChange,
    } = ContractorUpdateEmployeeApp({
        t,
        permission,
        params,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    });

    return (
        <>
            <HeadTittle link={routes.contractor.searchEmployee} name={t('update')}>
                <ButtonAction
                    id={'btn_cue_update'}
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={AddIcon}
                    onClick={() => {
                        validateEmail(user.email);
                        validatePhone(user.phoneNumber);
                        FormHandler();
                    }}
                />
                {showUnlinkBtn && <UnlinkDeviceBtn userId={user.userId} updated={() => setModified(true)} />}
            </HeadTittle>
            {extraDataEnabled ? (
                <ContractorEmployeeUpdateWithDetails
                    user={user}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    setUser={setUser}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    handleChange={handleChange}
                    headersList={headersList}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                />
            ) : (
                <ContractorEmployeeUpdateWithoutDetails
                    user={user}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    setUser={setUser}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                />
            )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};

export default ContractorCreateEmployee;
